import contact from './data/contacts'
import dialogues from './data/dialogues'
import {face, emoji} from './data/emoji'

const state = {
  ctx: null,
  currentVue: null,
  showLeaveAnim: true,
  title: '',
  contact: contact,
  dialogues: dialogues,

  face, emoji,

  init(ctx){
    this.ctx = ctx
  },


  logined: false,
  _index : 0,
  pushSerial(){
    this._index++
    return this._index;
  },


  timer: {
    second: 0,
    _timer: null,

    start: function(){
      let self = this

      if(this._timer != null){
        this.stop()
        this._timer = null
      }

      if(this._timer == null){
        this._timer = setInterval(() => {
          self.second ++
        }, 1000)
      }
    },

    stop: function(){
      let self = this
      if(this._timer != null){
        clearInterval(self._timer)
        self._timer = null
      }
    },
  },
  //记录地图上图标的位置
  marketPos: {}
}


export default state;



// WEBPACK FOOTER //
// ./src/store/state.js